import { render, staticRenderFns } from "./EricssonSiliconView.vue?vue&type=template&id=1cd7b85b&scoped=true&"
import script from "./EricssonSiliconView.vue?vue&type=script&lang=js&"
export * from "./EricssonSiliconView.vue?vue&type=script&lang=js&"
import style0 from "./EricssonSiliconView.vue?vue&type=style&index=0&id=1cd7b85b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd7b85b",
  null
  
)

export default component.exports